import { render, staticRenderFns } from "./ItemInfoViewLayout.vue?vue&type=template&id=b78b81a4&scoped=true"
import script from "./ItemInfoViewLayout.vue?vue&type=script&lang=js"
export * from "./ItemInfoViewLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78b81a4",
  null
  
)

export default component.exports